import React from 'react';
import { Instagram, Facebook, Twitter, Youtube, Mail, Phone, MapPin } from 'lucide-react';
import { footerData } from '../data/mockData';

const Footer = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Section */}
          <div className="space-y-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_066ade37-0f84-4c74-8e08-3866162c959b/artifacts/w36liy2d_Full%20Logo%20Blue.png"
              alt="Merdekaku.id" 
              className="h-10 brightness-0 invert"
            />
            <p className="text-gray-400 leading-relaxed">
              {footerData.about}
            </p>
            {/* Social Media */}
            <div className="flex space-x-4">
              <a
                href={footerData.socialMedia[0].url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-blue-600 transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href={footerData.socialMedia[1].url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-blue-600 transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={footerData.socialMedia[2].url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-blue-600 transition-all duration-300 hover:scale-110"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href={footerData.socialMedia[3].url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gray-800 p-3 rounded-full hover:bg-blue-600 transition-all duration-300 hover:scale-110"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Menu Cepat</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#about"
                  onClick={(e) => scrollToSection(e, '#about')}
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center group"
                >
                  <span className="w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-4 mr-2"></span>
                  Tentang Kami
                </a>
              </li>
              <li>
                <a
                  href="#projects"
                  onClick={(e) => scrollToSection(e, '#projects')}
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center group"
                >
                  <span className="w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-4 mr-2"></span>
                  Kegiatan
                </a>
              </li>
              <li>
                <a
                  href="#gallery"
                  onClick={(e) => scrollToSection(e, '#gallery')}
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center group"
                >
                  <span className="w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-4 mr-2"></span>
                  Galeri
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  onClick={(e) => scrollToSection(e, '#contact')}
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 flex items-center group"
                >
                  <span className="w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-4 mr-2"></span>
                  Kontak
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">Kontak</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-gray-400">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0 text-blue-400" />
                <a href={`mailto:${footerData.contact.email}`} className="hover:text-blue-400 transition-colors duration-300">
                  {footerData.contact.email}
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0 text-blue-400" />
                <a href={`tel:${footerData.contact.phone}`} className="hover:text-blue-400 transition-colors duration-300">
                  {footerData.contact.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0 text-blue-400" />
                <span>{footerData.contact.address}</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-bold mb-6">Tetap Terhubung</h3>
            <p className="text-gray-400 mb-4 text-sm">
              Ikuti perkembangan kegiatan sosial kami melalui media sosial
            </p>
            <div className="bg-gray-800 p-6 rounded-2xl border border-gray-700">
              <div className="flex items-center space-x-3 mb-3">
                <div className="bg-blue-600 p-2 rounded-lg">
                  <Mail className="w-5 h-5" />
                </div>
                <div>
                  <div className="font-semibold text-sm">Email Kami</div>
                  <div className="text-xs text-gray-400">Respons dalam 1-2 hari</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Merdekaku.id. Semua hak dilindungi.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">
                Kebijakan Privasi
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">
                Syarat & Ketentuan
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
